<template>
  <a-modal centered
    title="启动步骤"
    :width="1000"
    :visible="visible"
    @cancel="handleCancel"
    cancelText="关闭">
    <j-editor :key="editorKey"   v-model="editorText"  />
  </a-modal>
</template>

<script>
import { getBusServermanageServiceList,getServiceListByAppId } from '@/api/api.js'
import JEditor from '@/components/jeecg/JEditor'
export default {
  components:{
    JEditor
  },
  data() {
    return {
      editorText:"",
      visible:false,
      loading:false,
      editorKey:new Date().valueOf()
    }
  },
  methods:{
    handleCancel(){
      this.visible=false;
    },
    openNew(str) {
      this.visible = true;
      this.$nextTick(() => {
        this.editorKey = new Date().valueOf()
        this.editorText = str
      })
    },
    open(myId,shouType){
      this.visible=true;
      if(shouType === 1){
         this.loading = true
        getBusServermanageServiceList({serverId:myId})
          .then((res) => {
            if (res.success) {
              let editorTextTemp= res.result.records.reduce((dateStri,item)=>{
                return dateStri+`${item.type}:${item.name}<br/>${item.startStep?item.startStep:""}`
              },"")
              this.editorKey=new Date().valueOf()
              this.$nextTick(()=>{
                this.editorText = editorTextTemp?editorTextTemp:""
              })
            } else {
              this.$message.warning(res.message)
            }
          }).catch((err)=>{
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      }else if(shouType === 2){
        this.loading = true
        getServiceListByAppId({appId:myId})
          .then((res) => {
            if (res.success) {
              this.editorKey=new Date().valueOf()
              let editorTextTemp= res.result.records.reduce((dateStri,item)=>{
                return dateStri+`${item.type}:${item.name}<br/>${item.startStep?item.startStep:""}`
              },"")
              this.$nextTick(()=>{
                this.editorText = editorTextTemp?editorTextTemp:""
              })
            } else {
              this.$message.warning(res.message)
            }
          }).catch((err)=>{
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      }
      
    }
  }
}
</script>

<style>

</style>